/** Unknown paths for a signed-in visitor render the 404 page INSIDE the shell, as Next's 404.tsx did through _app. */
import { createFileRoute } from '@tanstack/react-router'

import NotFoundPage from '@/components/not-found-page'

export const Route = createFileRoute('/_shell/$')({ component: NotFoundPage })
